import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ErrorMessage = ({ message, style }) => (
  <ErrorMessageContainer style={style || {}}>
    {message}
  </ErrorMessageContainer>
);

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
  /* eslint-disable-next-line */
  style: PropTypes.object,
};

ErrorMessage.defaultProps = {
  style: {},
};

export default ErrorMessage;

const ErrorMessageContainer = styled.div`
  position: relative;
  border: 2px #ffd5da solid;
  border-radius: 5px;
  color: #ff5c6c;
  background-color: #ffd5da;
  padding: 5px;
  width: 95%;
  font-family: 'Karla', sans-serif;
  margin-top: 30px;
`;



// WEBPACK FOOTER //
// ./client/shared/ErrorMessage.js